









import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
    name: "Subjects",
    props: {
        plan: {
            type: Object,
            required: true
        }
    },
    computed: {
        subjects() {
            return _.get(this.plan, "program.subjects", []);
        }
    }
});
